import React, { useRef } from "react";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { SECTORS, IMAGES } from "@/data";
import { motion } from "framer-motion";

function SpotlightCard({ s, image, span }) {
  const ref = useRef(null);
  const onMove = (e) => {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    ref.current.style.setProperty("--mx", `${e.clientX - r.left}px`);
    ref.current.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      className={`group relative overflow-hidden rounded-2xl border border-white/5 bg-[#0C0C10] p-6 card-hover hover:border-white/15 ${span}`}
      data-testid={`sector-card-${s.n}`}
      style={{ background: "radial-gradient(400px circle at var(--mx) var(--my), rgba(0,87,255,0.10), transparent 45%), #0C0C10" }}
    >
      {image && (
        <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-700">
          <img src={image} alt={s.title} className="w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0C0C10] via-[#0C0C10]/60 to-transparent" />
        </div>
      )}
      <div className="relative z-10">
        <span className="font-mono text-xs text-[#0057FF]">{s.n}</span>
        <h3 className="font-head text-xl md:text-2xl font-medium mt-2">{s.title}</h3>
        <ul className="mt-4 space-y-1.5">
          {s.items.map((i) => <li key={i} className="text-sm text-zinc-500 group-hover:text-zinc-400 transition-colors">{i}</li>)}
        </ul>
        {s.note && <p className="mt-4 text-[11px] text-zinc-600 leading-relaxed border-t border-white/5 pt-3">{s.note}</p>}
      </div>
    </div>
  );
}

export default function Sectors() {
  const images = { "07": IMAGES.manufacturing, "06": IMAGES.robotics };
  const spans = { "01": "md:col-span-2", "07": "md:col-span-2" };
  return (
    <section id="build" className="relative py-24 md:py-36 border-t border-white/5" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionHeading label="What We Help Build" title="AI-native businesses that create measurable value." className="max-w-3xl" />
          <p className="mt-6 max-w-2xl text-base md:text-lg font-light text-zinc-400 leading-relaxed">
            We support AI-native and AI-enabled businesses that create measurable commercial, operational or industrial value.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {SECTORS.map((s, i) => (
            <motion.div key={s.n} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: (i % 3) * 0.08 }} className={spans[s.n] || ""}>
              <SpotlightCard s={s} image={images[s.n]} span="h-full" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
